import { Component, OnInit, Input } from '@angular/core';
import { IFundraiser } from '../../../../fundraiser/models/fundraiser.model';

@Component({
  selector: 'app-comment',
  templateUrl: './comment.component.html',
  styleUrls: ['./comment.component.scss']
})
export class CommentComponent implements OnInit {

  @Input() public comments;
  @Input() public fundraiser: IFundraiser;
  constructor() { }

  ngOnInit() {

  }

}
